//https://developer.chrome.com/multidevice/user-agent

const useDetectAndroidChrome = () =>
  navigator.userAgent.match(/(Android)/) && navigator.userAgent.match(/(Chrome\/[.0-9]* Mobile)/);

export default useDetectAndroidChrome;
